/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  EXPORT_TO_EXCEL_FAILURE,
  EXPORT_TO_EXCEL_SUCCESS,
} from "../actions/actionTypes";

export default function (state = {}, action) {
  switch (action.type) {
    case EXPORT_TO_EXCEL_SUCCESS:
      return {
        exportToExcelSuccess: true,
      };
    case EXPORT_TO_EXCEL_FAILURE:
      return {
        exportToExcelSuccess: false,
        error: action.errResp.message,
      };
    default:
      return state;
  }
}
